module.exports = __webpack_public_path__ + "img/1_018.2c8c7a0a.jpg";